/* *****************************
    Objet : Evenement
******************************** */
import { cacheGetters } from "../store/cache.module"

export const eveObj = {
    data: function () {
        return {
            objEvent: {
                eve_id: 0, eve_table_id: 'trs', eve_xxx_id  : '', eve_sta_id : 'GEN01',
                eve_typ_id: '', eve_title: '', eve_code: '', eve_description: '', 
                eve_date_start : null, eve_date_end : null, eve_value: 0, eve_cost_value: 0, 
                eve_delegation: 0, eve_resolve_percent: 0,
                eve_usr_id_own : '', eve_usr_id_creat: 0, 
                eve_lat: null, eve_lng: null, eve_custom_fields: {}, eve_doc_id_image: null,
                user: { data: [] }, contact: { data: [] }, equipment: { data: [] },
                _data: { contact: [], user: [], equipment: [], }
            },
            objEventClone: {},
            listEvent: [],
            metaEvent: {},
        }
    },
    mounted: function (){
        this.objEventClone = JSON.stringify( this.objEvent )
    },
    methods: {
        getEventFilter(page, perPage){
            page    = page || 1
            perPage = perPage || 'false'
            let filter = cacheGetters.getFilter()
            var searchCriteria = '?page='+ page +'&per_page=' + perPage + '&extended=true'
            for( var prop in filter ){
                if( filter[prop] !== undefined && filter[prop].length > 0 ){
                    searchCriteria += '&' + prop + '=' + filter[prop]
                }
            }
            return searchCriteria
        },
        // Get Event
        getEventShow(option){
            return new Promise( (resolve, reject) => {
                option = option || ''
                this.$http.get( '/events/' + this.objEvent.eve_id + '/' + option).then( (response) => {
                    var prop
                    for( prop in response.data.data ){
                        if( this.objEvent[prop] !== undefined ){
                            this.objEvent[prop] = response.data.data[prop] 
                        }
                    }
                    this.objEvent.eve_date_end   = ( this.objEvent.eve_date_end == '0000-00-00' ) ? null : this.objEvent.eve_date_end
                    this.objEvent.eve_date_start = ( this.objEvent.eve_date_start == '0000-00-00' ) ? null : this.objEvent.eve_date_start
                    this.objEvent.eve_custom_fields = (!this.objEvent.eve_custom_fields) ? {} : this.objEvent.eve_custom_fields
                    resolve('resolved')
                }).catch( (error) => { 
                    reject(error)
                })
            })
        },
        getEventIndex(option, page, perPage, order){
            return new Promise( (resolve, reject) => {
                option = option || ''
                order = order || ''
                this.listEvent = []
                //let searchCriteria = '' //this.getEventFilter(page, perPage)

                this.$http.get( '/events/' + option + order ).then( (response) => {
                    this.metaEvent = response.data.meta
                    if( Object.prototype.toString.call( response.data.data ) === '[object Array]' ) {
                        this.listEvent = response.data.data
                    }
                    resolve('resolved')
                }).catch( (error) => { 
                    reject(error)
                })
            })
        },
        putEventUpdate(){
            return new Promise( (resolve, reject) => {
                this.$http.put( '/events/' + this.objEvent.eve_id, this.objEvent ).then( (response) => {
                    this.objEvent.eve_id = response.data.data.eve_id
                    resolve('resolved')
                }).catch( (error) => { 
                    reject(error)
                })
            })
        },
        postEventStore(){
            return new Promise( (resolve, reject) => {
                let route = 'events'
                // for multiple store
                if( Object.prototype.toString.call( this.objEvent.eve_xxx_id ) === '[object Array]' ) {
                    route = 'events/multi'
                }
                this.$http.post( route, this.objEvent ).then( (response) => {
                    if( response.data.data ){
                        this.objEvent.eve_id = response.data.data.eve_id
                    }
                    resolve('resolved')
                }).catch( (error) => { 
                    reject(error)
                })
            })
        },
        deleteObjEvent(){
            return new Promise( (resolve, reject) => {
                this.$http.delete( '/events/' + this.objEvent.eve_id, this.objEvent ).then( () => {
                    this.objEvent.eve_id = 0
                    resolve('resolved')
                }).catch( (error) => { 
                    reject(error)
                })
            })
        },
        cleanObjEvent(){
            var EventClone = JSON.parse( this.objEventClone )
            var prop
            for( prop in EventClone ){
                if( this.objEvent[prop] !== undefined ){
                    this.objEvent[prop] = EventClone[prop]
                }
            }
        },
        getEventContactIndex(){
            return new Promise( (resolve, reject) => {
                this.$http.get( '/trackingsheets/' + this.objEvent.eve_id + '/contacts' ).then( (response) => {
                    response.data.data.forEach(typeState => {
                        if( this.objEvent._data['contacts'][typeState.ctr_typ_id][0].ctr_ctt_id === null ){
                            this.objEvent._data['contacts'][typeState.ctr_typ_id] = []
                        }
                        this.objEvent._data['contacts'][typeState.ctr_typ_id].push(typeState)
                    })
                    resolve('resolved')
                }).catch( (error) => { 
                    reject(error)
                })
            })
        },
        deleteEventContactCollection(deleteContact){
            return new Promise( (resolve, reject) => {
                if( deleteContact.length ){
                    this.$http.post( '/trackingsheets/' + this.objEvent.trs_id + '/contacts/deletes', { table:"trs", contacts: deleteContact } )
                    .then( () => {
                        resolve('resolved')
                    }).catch( (error) => { 
                        reject(error)
                    })
                } else {
                    resolve('resolved')
                }
            })
        },
        insertEventContactCollection(addContact){
            return new Promise( (resolve, reject) => {
                if( addContact.length ){
                    this.$http.post( '/trackingsheets/' + this.objEvent.trs_id + '/contacts/inserts', { table:"trs", contacts: addContact } )
                    .then( () => {
                        resolve('resolved')
                    }).catch( (error) => { 
                        reject(error)
                    })
                } else {
                    resolve('resolved')
                }
            })
        },
    }
}